import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { environment as env } from 'src/environments/environment';
import { QuoteTransfer } from "../models/quoteTransfer/QuoteTransfer";
import { QuoteTransferConvert } from "../models/quoteTransfer/quoteTransferConvert";


@Injectable()
export class QuoteTransferService {

    constructor(
        private http: HttpClient,
        private ngxLoaderService: NgxUiLoaderService,
      ) { }
    
    
  convertCase(quoteTransferd: QuoteTransferConvert): any {
    const url = `${env.apiEndpoint}/quotetransfer/convertCase`;
    return this.http.post<any>(url, quoteTransferd);
  }


  mergeCase(quoteTransferd: QuoteTransfer): any {
    const url = `${env.apiEndpoint}/quotetransfer/mergeCase`;
    return this.http.post<any>(url, quoteTransferd);
  }
}